export enum EPracticeType {
    // eslint-disable-next-line no-unused-vars
    ORGANIZATION = 'registration_contact_organization',
    // eslint-disable-next-line no-unused-vars
    PROFESSIONAL = 'registration_contact_professional',
}
